<mat-card fxLayoutGap class="p-3 d-flex flex-column gap-3">
  <div class="fw-semibold fs-4">Nuovo Provvedimento</div>
  <form [formGroup]="form" class="d-flex flex-column gap-3">
    <div>
      <app-dea-label [label]="'Data:'"></app-dea-label>
      <input type="date" formControlName="date" class="form-control dea-form-input" />
    </div>
    <div>
      <app-dea-label [label]="'Testo Provvedimento:'"></app-dea-label>
      <textarea formControlName="text" class="form-control dea-form-input" rows="4"></textarea>
    </div>
  </form>
  <div class="mt-3 gap-2" mat-dialog-actions align="center">
    <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()">Annulla</button>
    <button class="px-5 py-1" mat-flat-button color="primary" (click)="onConfirm()">
      Salva
    </button>
  </div>
</mat-card>